import { createSelector } from "reselect";
import { getProjectMembersById, getProjectLeaderById } from "./selector.projects.jsx";
import { getIsTaskHiddenFromClients, getProjectIdByTaskId } from "./selector.tasks.jsx";
import { getLoggedUserType, getLoggedUserId, hasLoggedUserElevatedPermissions } from "./selector.users.jsx";

export const getProjectMembersByTaskId = (state, taskId) => {
  return getProjectMembersById(state, getProjectIdByTaskId(state, taskId) || 0);
};

export const getProjectLeaderIdByTaskId = (state, taskId) => {
  return getProjectLeaderById(state, getProjectIdByTaskId(state, taskId) || 0);
};

export const makeGetCanLoggedUserEditTaskSelector = () => {
  return createSelector(
    getLoggedUserType,
    getLoggedUserId,
    hasLoggedUserElevatedPermissions,
    getProjectMembersByTaskId,
    getProjectLeaderIdByTaskId,
    getIsTaskHiddenFromClients,
    (loggedUserType, loggedUserId, hasElevatedPermissions, projectMembers, projectLeaderId, isTaskHidden) => {
      // owners can see/edit all tasks
      if (loggedUserType === `Owner`) {
        return true;
      }
      if (projectLeaderId === loggedUserId) {
        return true;
      }
      // non-owners have to be members on project to edit tasks
      if (projectMembers.indexOf(loggedUserId) > -1) {
        // clients can't see hidden tasks even if they have permissions to manage tasks
        if (isTaskHidden && loggedUserType === `Client`) {
          return false;
        }
        // clients can't edit tasks (unless they are client plus)
        return !!hasElevatedPermissions;
      }
      return false;
    }
  );
};
